<div>
  @if (!planningImageLoaded) {
    <div class="overlay">
      <div class="spinner"></div>
    </div>
  }

  <!-- Breadcrumb bar -->
  <div class="breadcrumb-bar">
    <div class="breadcrumb">
      <a class="breadcrumb-link" [routerLink]="['/dashboard']">Dashboard</a>
      <span class="breadcrumb-sep" aria-hidden="true"></span>
      <span class="breadcrumb-current">Planning</span>
    </div>
  </div>

  <!-- Planning Hero Area -->
  <main class="planning-hero">
    <div class="planning-content">
      <div class="planning-top-row">
        <h1 class="planning-title">Annual Schedule Planning</h1>
        <button class="view-listing-btn" routerLink="/review-management">VIEW REVIEW LISTING</button>
      </div>

      <div class="planning-form">
        <div class="select-wrapper">
          <select class="review-select" [class.has-value]="selectedReview !== null" [(ngModel)]="selectedReview"
            required #reviewModel="ngModel">
            <option [ngValue]="null" disabled hidden>Select Review</option>

            @for (opt of reviewOptions; track opt.ReviewTypeID) {
            <option [ngValue]="opt">{{ getReviewTypeLabel(opt) }}</option>
            }
          </select>
          <span class="select-chevron">
            <svg width="20" height="18" viewBox="0 0 24 24" fill="none" stroke="#222" stroke-width="3">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </span>
        </div>

        <div class="btn-row">
          <button class="add-review-btn" [disabled]="!reviewModel.valid" (click)="addNewReview()">Add New
            Review</button>

          @if (selectedReview?.ReviewTypeID === 1) {
          <button class="import-review-btn" routerLink="/planning/import-standard-review">
            Import Standard Review
          </button>
          }
        </div>
      </div>
    </div>
  </main>
</div>

